const Breadcrumbs = () => null

export default Breadcrumbs
